import React from 'react';

import { Answer, Program, School } from 'app/types';
import Text from 'common/components/Text/Text';

import styles from 'features/explore/school/SchoolDetail.module.scss';
import { useMediaQuery } from 'react-responsive';
import Loader from 'common/components/Loader/Loader';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { useGetSchoolAnswersQuery } from 'services/exploreApi';

import Accordion from 'react-bootstrap/Accordion';
import { entityIsProgram, entityIsSchool } from 'common/utils';

interface AnswerProps {
  number: string;
  answer: Answer;
}

interface CompProps {
  faqRef: React.RefObject<HTMLDivElement>;
  entity?: School | Program;
}

const AnswerComp = ({ number, answer }: AnswerProps): React.ReactElement => {
  return (
    <Accordion.Item eventKey={number} className={styles.accordionItem}>
      <Accordion.Header className={styles.title}>{answer.question.name}</Accordion.Header>
      <Accordion.Body className={styles.body}>{answer.value}</Accordion.Body>
    </Accordion.Item>
  );
};

export const FAQSection = ({ faqRef, entity }: CompProps): React.ReactElement => {
  const { schoolSlug } = useParams<{ schoolSlug: string }>();
  const [schoolId] = schoolSlug?.split('--') || [];
  const { data: answers, isLoading } = useGetSchoolAnswersQuery(
    entityIsSchool(entity) ? parseInt(schoolId) : entityIsProgram(entity) ? entity.school.id : -1
  );
  const isMobile = useMediaQuery({ maxWidth: 768 });
  if (isLoading) return <Loader />;
  return (
    <div className={styles.sectionContainer} ref={faqRef} id="faq">
      <div className={styles.sectionTitle}>
        <div className={styles.blueBlock} />
        <h3 className={styles.titleText}>FAQs and links</h3>
      </div>
      <div className={styles.faqContent}>
        <Accordion className={styles.accordion}>
          {answers?.data.map((answer: Answer, index: number) => (
            <AnswerComp number={String(index)} answer={answer} key={index} />
          ))}
        </Accordion>
        {entityIsSchool(entity) && (
          <Link className={styles.universityBox} to={entity?.website} target="_blank">
            <Text size={isMobile ? 14 : 16} weight={600}>
              {isMobile ? 'University Official Website' : `${entity?.name} official website`}
            </Text>
            <i className="bi bi-box-arrow-up-right" />
          </Link>
        )}
        {entityIsProgram(entity) && (
          <>
            {entity?.web_page && (
              <Link className={styles.universityBox} to={entity.web_page} target="_blank">
                <Text size={isMobile ? 14 : 16} weight={600}>
                  {isMobile ? 'Program Official Website' : `${entity.name} official website`}
                </Text>
                <i className="bi bi-box-arrow-up-right" />
              </Link>
            )}
            {entity?.school.website && (
              <Link className={styles.universityBox} to={entity.school.website} target="_blank">
                <Text size={isMobile ? 14 : 16} weight={600}>
                  {isMobile
                    ? 'University Official Website'
                    : `${entity?.school.name} official website`}
                </Text>
                <i className="bi bi-box-arrow-up-right" />
              </Link>
            )}
          </>
        )}
      </div>
    </div>
  );
};
